var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import moment from "moment";
import React, { useCallback, useContext, useEffect, useRef, useState, } from "react";
import { TAB_CHANGE_REFRESH_TIME } from "src/utils/constant";
import { getIndexPCRRatio, getRollover, } from "../../../apis/dashboard";
import { ThemeContext } from "../../../contexts/theme-context";
const { REACT_APP_URL_ASSET_BASE_PATH, REACT_APP_URL_CHART } = process.env;
import { useAppDispatch, useAppSelector } from "../../../hooks/redux";
import { convertNumberIntoLakhsAndCroreWithSign, getChartUrl, getEnvironmentVariableOrEmpty, intComma, } from "../../../utils/methods";
import { heartBeatData, subscribeToData, unsubscribeDataBySubscriber, } from "../../../utils/websocketwrapper";
import styles from "./overview.module.scss";
import { isNumeric } from "src/utils/methods";
import { SESSION_KEYS, getDataFromSession } from "src/utils/session-storage";
// ref forwarding needed here
// For understanding - https://github.com/react-grid-layout/react-grid-layout/issues/1241#issuecomment-859651584
const componentName = "OverviewDetails";
const OverviewDetails = React.forwardRef((_a, ref) => {
    var _b, _c;
    var { id, name, spotToken, symbol, scripCode, expiry, exch, exchType, indicatorWidgetSymbol, indexPCR } = _a, others = __rest(_a, ["id", "name", "spotToken", "symbol", "scripCode", "expiry", "exch", "exchType", "indicatorWidgetSymbol", "indexPCR"]);
    const dispatch = useAppDispatch();
    // const [indexPCR, setIndexPCR]: any = useState();
    const [indexPCRatio, setIndexPCRatio] = useState();
    //const [indexPCRBank, setIndexPCRBank]: any = useState();
    const [rollOver, setRollover] = useState([]);
    const [spotValue, setSpotValue] = useState(0);
    const [premDiscWs, setPremDiscWs] = useState(0);
    const [oiValue, setOiValue] = useState(0);
    const [showChart, setShowChart] = useState(true);
    const blurTime = useAppSelector((state) => state.app.windowBlurTime);
    const [counter, setCounter] = useState(0);
    const [chartTypeData, setChartTypeData] = useState("Area");
    const [scripPriceData, setScripPriceData] = useState({
        PClose: 0,
        LastRate: 0,
        Token: 0,
        Expiry: "",
    });
    // console.log("This is Overview reloading");
    // const iframeRef = useRef<HTMLIFrameElement>(null);
    const [showMore, setShowMore] = useState(false);
    //added for theming the chart using context api
    const { theme } = useContext(ThemeContext);
    const intervalRef = useRef(undefined);
    // const url = `https://tradechart.5paisa.com/index.html?type=overview&period=1&exchange=nse&exchType=D&range=d&symbol=${symbol}&scripCode=${scripCode}&appName=5Paisa&appVer=5.11.6.0&osName=Windows&loginId=0&theme=Light&source=derivative&chartType=${chartTypeData}`;
    const getUrl = useCallback(() => {
        const localExpiry = moment(expiry).format("DD MMM YY");
        // getScripType(singleData.fullName, singleData.exchange, singleData.exchType);
        const chartData = {
            fullName: name.split(" ")[0] + " " + localExpiry,
            strikePrice: undefined,
            exchange: exch,
            exchangeType: exchType,
            expiry: localExpiry,
            symbol: name.split(" ")[0],
            scripCode: scripCode,
        };
        // console.log(isWindowFocused, " Chart get rerender");
        return getChartUrl(chartData, `${getEnvironmentVariableOrEmpty(REACT_APP_URL_CHART)}/index.html?chartType=${chartTypeData}&counter=${counter}&`);
    }, [
        expiry,
        name,
        exch,
        exchType,
        scripCode,
        chartTypeData,
        theme,
        counter,
    ]);
    useEffect(() => {
        if (showChart) {
            // if (iframeRef && iframeRef.current != null) {
            //   //only for testing
            //   // iframeRef.current.onload = (event) => {
            //   //   console.log("Iframe url loaded");
            //   // };
            // }
            if (blurTime >= TAB_CHANGE_REFRESH_TIME) {
                setCounter(counter + 1);
            }
        }
    }, [showChart, blurTime]);
    const openFeedWsHeartBeat = useAppSelector((state) => state.openFeedWs.heartBeat);
    const openFeedWsMsg = useAppSelector((state) => {
        // const isPresent = state.openFeedWs.componentNames.find(
        //   (singleCompName) => {
        //     return singleCompName == componentName;
        //   }
        // );
        // if (isPresent) {
        return state.openFeedWs.message;
        // }
    });
    const sendWsMessage = (heartBeatMessage) => {
        if (scripCode == 0) {
            return;
        }
        const clientCode = getDataFromSession(SESSION_KEYS.CLIENT_CODE);
        const method1 = {
            Method: "MarketFeedV3",
            Operation: "Subscribe",
            ClientCode: clientCode,
            MarketFeedData: [
                { Exch: exch, ExchType: exchType, ScripCode: scripCode },
                { Exch: exch, ExchType: "C", ScripCode: spotToken },
            ],
        };
        const method2 = {
            Method: "GetScripInfoForFuture",
            Operation: "Subscribe",
            ClientCode: clientCode,
            MarketFeedData: [
                { Exch: exch, ExchType: exchType, ScripCode: scripCode },
            ],
        };
        if (heartBeatMessage) {
            heartBeatData(method1, componentName, () => { });
            heartBeatData(method2, componentName, () => { });
        }
        else {
            subscribeToData(method1, componentName, () => { });
            subscribeToData(method2, componentName, () => { });
        }
    };
    const onChangeShowmore = () => {
        setShowMore(!showMore);
        setShowChart(!showChart);
    };
    useEffect(() => {
        sendWsMessage(openFeedWsHeartBeat);
    }, [openFeedWsHeartBeat, scripCode]);
    useEffect(() => {
        if (openFeedWsMsg) {
            updateDetailsFromWS(openFeedWsMsg);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [openFeedWsMsg]);
    const updateDetailsFromWS = (update) => {
        const newScripDetails = scripPriceData;
        if (Array.isArray(update)) {
            update = update[0];
        }
        if ((update === null || update === void 0 ? void 0 : update.Details) === undefined && (update === null || update === void 0 ? void 0 : update.OpenInterest) == undefined) {
            if (scripCode == (update === null || update === void 0 ? void 0 : update.Token)) {
                newScripDetails.LastRate = update.LastRate;
                newScripDetails.PClose = update.PClose;
                setScripPriceData(newScripDetails);
                if (update.LastRate > 0 && spotValue > 0) {
                    setPremDiscWs(update.LastRate - spotValue);
                }
            }
            if ((update === null || update === void 0 ? void 0 : update.Token) == spotToken) {
                setSpotValue(update.LastRate);
                if (newScripDetails.LastRate > 0 && update.LastRate > 0) {
                    setPremDiscWs(newScripDetails.LastRate - update.LastRate);
                }
            }
        }
        else {
            if (scripCode == (update === null || update === void 0 ? void 0 : update.Token)) {
                setOiValue(update.OpenInterest);
            }
        }
    };
    // const fetchIndexPCR = async (): Promise<void> => {
    //   try {
    //     const resultFromIndexPCR: any = await getIndexPCR(
    //       name.split(" ")[0].toLowerCase()
    //     );
    //     setIndexPCR(
    //       resultFromIndexPCR?.data.response?.data?.companylist?.company
    //     );
    //   } catch (err) {
    //     console.error(err);
    //   }
    // };
    const fetchIndexPCRatio = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        var _d, _e, _f, _g, _h, _j, _k, _l;
        try {
            const splitted_name = name.split(" ")[0].toUpperCase();
            const unknowntype = splitted_name === "NIFTY" ||
                splitted_name === "BANKNIFTY" ||
                splitted_name === "BANKNIFTY"
                ? "idx"
                : "stk";
            const stock_name = splitted_name;
            const resultFromIndexPCRatio = yield getIndexPCRRatio(unknowntype, "vol", "all", stock_name, "all");
            const resultFromIndexPCRatio_filtered = (_g = (_f = (_e = (_d = resultFromIndexPCRatio === null || resultFromIndexPCRatio === void 0 ? void 0 : resultFromIndexPCRatio.data) === null || _d === void 0 ? void 0 : _d.response) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.getputcallratiolist) === null || _g === void 0 ? void 0 : _g.getputcallratio;
            resultFromIndexPCRatio_filtered.sort((o1, o2) => {
                if (moment(o1 === null || o1 === void 0 ? void 0 : o1.expdate).toDate() < moment(o2 === null || o2 === void 0 ? void 0 : o2.expdate).toDate())
                    return -1;
                else if (moment(o1 === null || o1 === void 0 ? void 0 : o1.expdate).toDate() > moment(o2 === null || o2 === void 0 ? void 0 : o2.expdate).toDate())
                    return 1;
                else
                    return 0;
            });
            setIndexPCRatio(resultFromIndexPCRatio_filtered
                ? resultFromIndexPCRatio_filtered
                : (_l = (_k = (_j = (_h = resultFromIndexPCRatio === null || resultFromIndexPCRatio === void 0 ? void 0 : resultFromIndexPCRatio.data) === null || _h === void 0 ? void 0 : _h.response) === null || _j === void 0 ? void 0 : _j.data) === null || _k === void 0 ? void 0 : _k.getputcallratiolist) === null || _l === void 0 ? void 0 : _l.getputcallratio);
        }
        catch (err) {
            console.error(err);
        }
    }), []);
    // const fetchIndexPCRBank = async (): Promise<void> => {
    //   try {
    //     const resultFromIndexPCRBank: any = await getIndexPCR(name);
    //     setIndexPCRBank(
    //       resultFromIndexPCRBank?.data?.response?.data?.companylist?.company
    //     );
    //   } catch (err) { }
    // };
    const fetchRollover = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const resultFromRollover = yield getRollover();
            let fnoRolloverData = resultFromRollover.data.response.data.FNORollOverList.FNORollOverdata;
            fnoRolloverData = fnoRolloverData.filter((item) => (item === null || item === void 0 ? void 0 : item.Symbol.toLowerCase()) === symbol.toLowerCase());
            setRollover(fnoRolloverData);
        }
        catch (err) {
            console.error(err);
        }
    });
    const fetchApis = () => {
        //fetchIndexPCRBank();
        //fetchIndexPCR();
        fetchIndexPCRatio();
        fetchRollover();
    };
    useEffect(() => {
        fetchApis();
        intervalRef.current = setInterval(() => {
            fetchApis();
        }, 60000);
        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
                intervalRef.current = undefined;
            }
        };
    }, []);
    // const lotSize =
    //   id == "NIFTY" ? indexPCR?.[0]?.marketlot : indexPCRBank?.[0]?.marketlot;
    // const OI =
    //   id == "NIFTY"
    //     ? indexPCR?.[0]?.openinterest
    //     : indexPCRBank?.[0]?.openinterest;
    // // setOiValue(OI);
    // const pcRatio =
    //   id == "NIFTY"
    //     ? indexPCRatio?.[0]?.PCRatioOI
    //     : indexPCRatio?.[3]?.PCRatioOI;
    // const premDisc =
    //   id == "NIFTY" ? indexPCR?.[0]?.basis : indexPCRBank?.[0]?.basis;
    // const turnOver =
    //   id == "NIFTY" ? indexPCR?.[0]?.turnover : indexPCRBank?.[0]?.turnover;
    // const rollover =
    //   id == "NIFTY" ? rollOver?.[1]?.ROPer : rollOver?.[0]?.ROPer;
    // const averagePrice =
    //   id == "NIFTY" ? indexPCR?.[0]?.avgprice : indexPCRBank?.[0]?.avgprice;
    //console.log('KK indexPCR',indexPCR);
    const splitted_name = name.split(" ")[0].toUpperCase();
    const lotSize = indexPCR === null || indexPCR === void 0 ? void 0 : indexPCR.marketlot;
    const OI = indexPCR === null || indexPCR === void 0 ? void 0 : indexPCR.openinterest;
    const pcRatio = (_b = indexPCRatio === null || indexPCRatio === void 0 ? void 0 : indexPCRatio[0]) === null || _b === void 0 ? void 0 : _b.PCRatioOI; //need clearification
    const turnOver = indexPCR === null || indexPCR === void 0 ? void 0 : indexPCR.turnover;
    const rollover = (_c = rollOver === null || rollOver === void 0 ? void 0 : rollOver[0]) === null || _c === void 0 ? void 0 : _c.ROPer;
    const averagePrice = indexPCR === null || indexPCR === void 0 ? void 0 : indexPCR.avgprice;
    //unmount effect
    useEffect(() => {
        return () => {
            //unmount call here
            unsubscribeDataBySubscriber(componentName);
        };
    }, []);
    const getOi = () => {
        if (OI) {
            if (oiValue > 0) {
                return oiValue;
            }
            else {
                return OI;
            }
        }
        else {
            return oiValue;
        }
    };
    return (_jsxs("ul", Object.assign({ className: styles.viewDataList }, { children: [_jsxs("li", { children: [_jsx("span", { children: "OI" }), _jsx("span", { children: getOi() === 0
                            ? "-"
                            : convertNumberIntoLakhsAndCroreWithSign(getOi()) })] }), _jsxs("li", { children: [_jsx("span", { children: "Spot" }), _jsx("span", { children: spotValue === 0 ? "-" : intComma(spotValue) })] }), _jsxs("li", { children: [_jsx("span", { children: "PCR" }), _jsx("span", { children: isNumeric(pcRatio) ? intComma(pcRatio) : "-" })] }), _jsxs("li", { children: [_jsx("span", { children: "Prem/Disc" }), _jsx("span", { children: intComma(premDiscWs === 0 ? "-" : premDiscWs) })] }), _jsxs("li", { children: [_jsx("span", { children: "Turnover (Lakhs)" }), _jsx("span", { children: intComma((Number(turnOver) / 100000).toFixed(2)) })] }), _jsxs("li", { children: [_jsx("span", { children: "Roll Over" }), _jsx("span", { children: isNumeric(rollover) ? intComma(rollover) + "%" : "-" })] }), _jsxs("li", { children: [_jsx("span", { children: "Average Price" }), _jsx("span", { children: isNumeric(averagePrice) ? intComma(averagePrice) : "-" })] }), _jsxs("li", { children: [_jsx("span", { children: "Lot Size" }), _jsx("span", { children: isNumeric(lotSize) ? intComma(lotSize, 0) : "-" })] })] })));
});
OverviewDetails.displayName = "OverviewDetails";
export default OverviewDetails;
